import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchApiData } from "../../../redux/reducers/commonApiSlice";
import { convertStraight } from "../../common-data/Converts";
import {
  DropIcon,
  FireIcon,
  FlashLightIcon,
  GoalIcon,
  GreenGlobeIcon,
  PersonIcon1,
  ResultIcon,
  TargetIcon,
  TrendingUpIcon2,
  WeightIcon,
} from "../../../images/icons/icons";
import CalendarLoader from "../../common-components/CalendarLoader";

const MemberFitnessProfileLogs = ({ activeTab, userInfoData, rowData }) => {
  const dispatch = useDispatch();
  const { data, loading, error } = useSelector((state) => state.common);

  const [allMemberFitnessInfo, setAllMemberFitnessInfo] = useState([]);
  const [pagination, setPagination] = useState([]);

  function getMemberInfo(filters) {
    const endpoint = "/member/fitness_profiles_logs";

    dispatch(
      fetchApiData({
        method: "GET",
        endpoint: endpoint,
        payload: {
          filters: filters,
        },
        token: userInfoData?.token,
      })
    );
  }

  const getActivityLabel = (howactive) => {
    const activityMap = {
      light: "Lightly Active",
      moderate: "Moderately Active",
      very: "Very Active",
      extra: "Extremely Active",
      sedentary: "Sedentary",
    };
    return activityMap[howactive] || howactive;
  };

  const getResultColor = (result) => {
    if (result?.toLowerCase().includes("healthy"))
      return "member-profile-bottom-value-healthy";
    return "fitness-result member-profile-bottom-value";
  };

  useEffect(() => {
    if (activeTab === "fitness-profile") {
      if (rowData?.user_id) {
        const sendableFilters = {
          user_id: rowData?.user_id || "",
          page: 1,
          limit: 1000,
        };

        getMemberInfo(sendableFilters);
      } else if (!rowData?.user_id) {
        setAllMemberFitnessInfo([]);
        setPagination([]);
      }
    }
  }, [activeTab]);

  useEffect(() => {
    if (activeTab === "fitness-profile" && rowData?.user_id) {
      if (!loading && !error && data?.status && data?.data) {
        setAllMemberFitnessInfo(data.data);
        setPagination(data?.pagination);
      } else {
        setAllMemberFitnessInfo([]);
        setPagination([]);
      }
    }
  }, [activeTab, data, loading, error]);

  if (!loading && (error || allMemberFitnessInfo?.length === 0)) {
    return (
      <div className="error-container">
        <p>No fitness profile logs found for this member.</p>
      </div>
    );
  }

  return (
    <div className="member-profile-fitness-logs-container">
      <h3 className="member-profile-logs-total">
        Total: {pagination?.[0]?.pagination || allMemberFitnessInfo.length} logs
      </h3>

      <div className="member-profile-logs-wrapper">
        {loading ? (
          <CalendarLoader daysCount={3} />
        ) : (
          allMemberFitnessInfo.map((log, index) => (
            <div key={index} className="member-profile-fitness-log-card">
              <div className="member-profile-log-header">
                <h2 className="member-profile-log-title">
                  Fitness Log <b>{allMemberFitnessInfo.length - index}</b>
                </h2>
                <span className="member-profile-log-date">
                  Added On:{" "}
                  {log.log_date ||
                    convertStraight(
                      new Date(parseInt(log.date_added)).toISOString()
                    )}
                </span>
              </div>

              <div className="member-profile-stats-grid">
                <div className="member-profile-stat-card">
                  <div className="member-profile-stat-icon">
                    <WeightIcon color="#ef4443" />
                  </div>
                  <div className="member-profile-stat-label">Weight</div>
                  <div className="member-profile-stat-value">
                    {parseFloat(log?.current_weight || 0).toFixed(1)} Kg
                  </div>
                </div>

                <div className="member-profile-stat-card">
                  <div className="member-profile-stat-icon">
                    <TargetIcon color="#E41815" />
                  </div>
                  <div className="member-profile-stat-label">Target Weight</div>
                  <div className="member-profile-stat-value">
                    {parseFloat(log?.target_weight || 0).toFixed(1)} Kg
                  </div>
                </div>

                <div className="member-profile-stat-card">
                  <div className="member-profile-stat-icon">
                    <FireIcon color="#E41815" />
                  </div>
                  <div className="member-profile-stat-label">Calorie</div>
                  <div className="member-profile-stat-value">
                    {parseFloat(log?.current_calorie_result || 0).toFixed(1)}
                  </div>
                </div>

                <div className="member-profile-stat-card">
                  <div className="member-profile-stat-icon">
                    <GreenGlobeIcon color="#E41815" />
                  </div>
                  <div className="member-profile-stat-label">
                    Target Calorie
                  </div>
                  <div className="member-profile-stat-value">
                    {parseFloat(log?.calorie_target_result || 0).toFixed(1)}
                  </div>
                </div>

                <div className="member-profile-stat-card">
                  <div className="member-profile-stat-icon">
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      // fill="#157EF9"
                      fill="#E41815"
                    >
                      <path d="M3,13H5V21H3V13M7,9H9V21H7V9M15,16H17V21H15V16M19,10H21V21H19V10M11,3H13V21H11V3Z" />
                    </svg>
                  </div>
                  <div className="member-profile-stat-label">BMI</div>
                  <div className="member-profile-stat-value">
                    {parseFloat(log?.bmi_result || 0).toFixed(1)}
                  </div>
                </div>

                <div className="member-profile-stat-card">
                  <div className="member-profile-stat-icon">
                    <FlashLightIcon
                      // color="#f59f0a"
                      color="#E41815"
                    />
                  </div>
                  <div className="member-profile-stat-label">TDEE</div>
                  <div className="member-profile-stat-value">
                    {parseFloat(log?.tdee || 0).toFixed(0)}
                  </div>
                </div>

                <div className="member-profile-stat-card">
                  <div className="member-profile-stat-icon">
                    <DropIcon color="#E41815" />
                  </div>
                  <div className="member-profile-stat-label">FAT</div>
                  <div className="member-profile-stat-value">
                    {parseFloat(log?.fat_result || 0).toFixed(1)}%
                  </div>
                </div>

                <div className="member-profile-stat-card">
                  <div className="member-profile-stat-icon">
                    <TrendingUpIcon2
                      // color="#9c9c9c"
                      color="#E41815"
                    />
                  </div>
                  <div className="member-profile-stat-label">How Active</div>
                  <div className="member-profile-stat-value-small">
                    {getActivityLabel(log?.how_active || "-")}
                  </div>
                </div>
              </div>

              <div className="member-profile-bottom-grid">
                <div className="member-profile-bottom-card">
                  <div className="member-profile-bottom-icon">
                    <GoalIcon
                      // color="#E41815"
                      color="#F5AD18"
                    />
                  </div>
                  <div>
                    <div className="member-profile-bottom-label">Goal</div>
                    <div className="member-profile-bottom-value">
                      {log.goal || "-"}
                    </div>
                  </div>
                </div>

                <div className="member-profile-bottom-card">
                  <div className="member-profile-bottom-icon">
                    <PersonIcon1
                      // color="#E41815"
                      color="#F5AD18"
                    />
                  </div>
                  <div>
                    <div className="member-profile-bottom-label">Body Type</div>
                    <div className="member-profile-bottom-value">
                      {log.body_type || "-"}
                    </div>
                  </div>
                </div>

                <div className="member-profile-bottom-card">
                  <div className="member-profile-bottom-icon">
                    <ResultIcon
                      // color="#E41815"
                      color="#F5AD18"
                    />
                  </div>
                  <div>
                    <div className="member-profile-bottom-label">
                      Fitness Result
                    </div>
                    <div className={getResultColor(log.result_value)}>
                      {log.result_value || "-"}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default MemberFitnessProfileLogs;
